import { render, staticRenderFns } from "./PhoneResult.vue?vue&type=template&id=2a81cf43&scoped=true&"
import script from "./PhoneResult.vue?vue&type=script&lang=js&"
export * from "./PhoneResult.vue?vue&type=script&lang=js&"
import style0 from "./PhoneResult.vue?vue&type=style&index=0&id=2a81cf43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a81cf43",
  null
  
)

export default component.exports